<ng-container *ngIf="component.data$ | async as data">
  <p [attr.class]="data.styleClasses? data.styleClasses : null"
     [innerHTML]="data.content | cxSupplementHashAnchors"
  >
  </p>
</ng-container>
